/** Filtro de um dashboard num ambiente, como o backend guarda (e como vai para a URL do Power BI). */
export interface Filtro {
  id: number
  table: string
  colunm: string
  operator: string
  acumulator: string
  environmentId?: number | null
  type: 'STATIC' | 'VARIABLE' | string
  value: string
}

export interface FiltroForm {
  id?: number
  tabela: string
  coluna: string
  condicao: string
  /** "FIXO" ou uma das variáveis (USER_EMAIL…). */
  origem: string
  valor: string
  numero: boolean
}

export const CONDICOES = [
  { valor: 'EQ', rotulo: 'é igual a' },
  { valor: 'NE', rotulo: 'é diferente de' },
  { valor: 'IN', rotulo: 'é um destes' },
  { valor: 'GT', rotulo: 'é maior que' },
  { valor: 'GE', rotulo: 'é maior ou igual a' },
  { valor: 'LT', rotulo: 'é menor que' },
  { valor: 'LE', rotulo: 'é menor ou igual a' }
]

export const VARIAVEIS = [
  { valor: 'USER_EMAIL', rotulo: 'E-mail', exemplo: 'MARIA@EMPRESA.COM' },
  { valor: 'USER_NAME', rotulo: 'Nome', exemplo: 'MARIA SILVA' },
  { valor: 'USER_CPF', rotulo: 'CPF', exemplo: '12345678900' },
  { valor: 'USER_COMPANY', rotulo: 'Empresa', exemplo: 'EMPRESA' },
  { valor: 'ENVIRONMENT_NAME', rotulo: 'Nome do ambiente', exemplo: 'NOME DO AMBIENTE' }
]

export function filtroVazio(): FiltroForm {
  return { tabela: '', coluna: '', condicao: 'EQ', origem: 'FIXO', valor: '', numero: false }
}

const aspas = (v: string) => `'${v.replace(/'/g, "''")}'`

/** O valor fixo no formato do filtro de URL: 'SP', 10, ('A','B'). */
export function literal(condicao: string, texto: string, numero: boolean): string {
  const itens = condicao === 'IN' ? texto.split(',').map(s => s.trim()).filter(Boolean) : [texto.trim()]
  const um = (v: string) => (numero ? v : aspas(v))
  return condicao === 'IN' ? `(${itens.map(um).join(',')})` : um(itens[0] || '')
}

/** Lê o valor gravado de volta para a tela: tira parênteses e aspas. */
export function lerLiteral(bruto: string): { valor: string; numero: boolean } {
  let v = (bruto || '').trim()
  if (v.startsWith('(') && v.endsWith(')')) v = v.slice(1, -1)
  const itens: string[] = []
  let numero = true
  // Separa por vírgula fora das aspas; '' dentro das aspas é uma aspa.
  let atual = '', dentro = false
  for (let i = 0; i < v.length; i++) {
    const c = v[i]
    if (c === "'") {
      if (dentro && v[i + 1] === "'") { atual += "'"; i++; continue }
      dentro = !dentro; numero = false; continue
    }
    if (c === ',' && !dentro) { itens.push(atual.trim()); atual = ''; continue }
    atual += c
  }
  itens.push(atual.trim())
  return { valor: itens.filter(Boolean).join(', '), numero }
}

export function formDoFiltro(f: Filtro): FiltroForm {
  const variavel = f.type === 'VARIABLE'
  const lido = variavel ? { valor: '', numero: false } : lerLiteral(f.value)
  return { id: f.id, tabela: f.table, coluna: f.colunm, condicao: (f.operator || 'EQ').toUpperCase(), origem: variavel ? f.value : 'FIXO', ...lido }
}

/** O filtro numa frase: "dCliente[GRUPO] é igual a 'X'". */
export function fraseDoFiltro(f: Filtro): string {
  const cond = CONDICOES.find(c => c.valor === (f.operator || '').toUpperCase())?.rotulo || f.operator
  if (f.type !== 'VARIABLE') return `${f.table}[${f.colunm}] ${cond} ${lerLiteral(f.value).valor}`
  // 'é igual a' + 'o e-mail' vira 'é igual ao e-mail'.
  const de = (VARIAVEIS.find(v => v.valor === f.value)?.rotulo || f.value).toLowerCase() + ' de quem abre'
  const ligado = / a$/.test(cond) ? cond + 'o' : / de$/.test(cond) ? cond.replace(/ de$/, ' do') : cond + ' o'
  return `${f.table}[${f.colunm}] ${ligado} ${de}`
}
